module.exports = __webpack_public_path__ + "img/sym-order-02.1ac8e08a.svg";